/* eslint-disable no-nested-ternary */

import styled from 'styled-components';
import { ColorHealth5, ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import type { BasketMessageGwpViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import format from 'helpers/translations';
import BasketMessageContainer from '../shared/styles';

const StyledBasketMessageContainer = styled(BasketMessageContainer)<{ $type: BasketMessageGwpViewModel['type'] }>`
    background-color: ${({ $type }) => {
        switch ($type) {
            case 'Achievement':
                return ColorHealth5;
            default:
                return ColorNordicGrey4;
        }
    }};
`;

export default function GwpMessage({ model: { text, type } }: { model: BasketMessageGwpViewModel }) {
    return (
        <StyledBasketMessageContainer $type={type}>
            <Typography.Body as="span" size="S">
                {format(text)}
            </Typography.Body>
        </StyledBasketMessageContainer>
    );
}
